import ScratchBlocks from 'openblock-blocks';

import {eventBlock} from './libraries/devices/index.jsx';

const categorySeparator = '<sep gap="36"/>';

const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px

/* eslint-disable no-unused-vars */
const motion = function (isInitialSetup, isStage, targetId) {
    const stageSelected = ScratchBlocks.ScratchMsgs.translate(
        'MOTION_STAGE_SELECTED',
        'Stage selected: no motion blocks'
    );
    return `
    <category name="%{BKY_CATEGORY_MOTION}" id="motion" colour="#4C97FF" secondaryColour="#3373CC">
        ${isStage ? `
        <label text="${stageSelected}"></label>
        ` : `
        <block type="motion_movesteps">
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnright">
            <value name="DEGREES">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnleft">
            <value name="DEGREES">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_goto">
            <value name="TO">
                <shadow type="motion_goto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_gotoxy">
            <value name="X">
                <shadow id="movex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="movey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_glideto" id="motion_glideto">
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="motion_glideto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_glidesecstoxy">
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="X">
                <shadow id="glidex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="glidey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_pointindirection">
            <value name="DIRECTION">
                <shadow type="math_angle">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        <block type="motion_pointtowards">
            <value name="TOWARDS">
                <shadow type="motion_pointtowards_menu">
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_changexby">
            <value name="DX">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_setx">
            <value name="X">
                <shadow id="setx" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_changeyby">
            <value name="DY">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_sety">
            <value name="Y">
                <shadow id="sety" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_ifonedgebounce"/>
        ${blockSeparator}
        <block type="motion_setrotationstyle"/>
        ${blockSeparator}
        <block id="${targetId}_xposition" type="motion_xposition"/>
        <block id="${targetId}_yposition" type="motion_yposition"/>
        <block id="${targetId}_direction" type="motion_direction"/>`}
        ${categorySeparator}
    </category>
    `;
};

const xmlEscape = function (unsafe) {
    return unsafe.replace(/[<>&'"]/g, c => {
        switch (c) {
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '&': return '&amp;';
        case '\'': return '&apos;';
        case '"': return '&quot;';
        }
    });
};

const looks = function (isInitialSetup, isStage, targetId, costumeName, backdropName) {
    const hello = ScratchBlocks.ScratchMsgs.translate('LOOKS_HELLO', 'Hello!');
    const hmm = ScratchBlocks.ScratchMsgs.translate('LOOKS_HMM', 'Hmm...');
    return `
    <category name="%{BKY_CATEGORY_LOOKS}" id="looks" colour="#9966FF" secondaryColour="#774DCB">
        ${isStage ? '' : `
        <block type="looks_sayforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_say">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
        </block>
        <block type="looks_thinkforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_think">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        `}
        ${isStage ? `
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_switchbackdroptoandwait">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
        ` : `
            <block id="${targetId}_switchcostumeto" type="looks_switchcostumeto">
                <value name="COSTUME">
                    <shadow type="looks_costume">
                        <field name="COSTUME">${costumeName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextcostume"/>
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
            ${blockSeparator}
            <block type="looks_changesizeby">
                <value name="CHANGE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_setsizeto">
                <value name="SIZE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>
        `}
        ${blockSeparator}
        <block type="looks_changeeffectby">
            <value name="CHANGE">
                <shadow type="math_number">
                    <field name="NUM">25</field>
                </shadow>
            </value>
        </block>
        <block type="looks_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="looks_cleargraphiceffects"/>
        ${blockSeparator}
        ${isStage ? '' : `
            <block type="looks_show"/>
            <block type="looks_hide"/>
        ${blockSeparator}
            <block type="looks_gotofrontback"/>
            <block type="looks_goforwardbackwardlayers">
                <value name="NUM">
                    <shadow type="math_integer">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
            </block>
        `}
        ${isStage ? `
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
        ` : `
            <block id="${targetId}_costumenumbername" type="looks_costumenumbername"/>
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
            <block id="${targetId}_size" type="looks_size"/>
        `}
        ${categorySeparator}
    </category>
    `;
};

const sound = function (isInitialSetup, isStage, targetId, soundName) {
    return `
    <category name="%{BKY_CATEGORY_SOUND}" id="sound" colour="#D65CD6" secondaryColour="#BD42BD">
        <block id="${targetId}_sound_playuntildone" type="sound_playuntildone">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_sound_play" type="sound_play">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block type="sound_stopallsounds"/>
        ${blockSeparator}
        <block type="sound_changeeffectby">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block type="sound_cleareffects"/>
        ${blockSeparator}
        <block type="sound_changevolumeby">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">-10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_setvolumeto">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_volume" type="sound_volume"/>
        ${categorySeparator}
    </category>
    `;
};

const events = function (isInitialSetup, isStage) {
    return `
    <category name="%{BKY_CATEGORY_EVENTS}" id="events" colour="#FFD500" secondaryColour="#CC9900">
        <block type="event_whenflagclicked"/>
        <block type="event_whenkeypressed">
        </block>
        ${isStage ? `
            <block type="event_whenstageclicked"/>
        ` : `
            <block type="event_whenthisspriteclicked"/>
        `}
        <block type="event_whenbackdropswitchesto">
        </block>
        ${blockSeparator}
        <block type="event_whengreaterthan">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="event_whenbroadcastreceived">
        </block>
        <block type="event_broadcast">
            <value name="BROADCAST_INPUT">
                <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        <block type="event_broadcastandwait">
            <value name="BROADCAST_INPUT">
              <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const control = function (isInitialSetup, isStage, targetId, isRealtimeMode) {
    return `
    <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
        <block type="control_wait">
            <value name="DURATION">
                <shadow type="math_positive_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="control_repeat">
            <value name="TIMES">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block id="forever" type="control_forever"/>
        ${blockSeparator}
        <block type="control_if"/>
        <block type="control_if_else"/>
        <block id="wait_until" type="control_wait_until"/>
        <block id="repeat_until" type="control_repeat_until"/>
        ${blockSeparator}
        ${isRealtimeMode ? `
            <block type="control_stop"/>
            ${blockSeparator}
            ${isStage ? `
                <block type="control_create_clone_of">
                    <value name="CLONE_OPTION">
                        <shadow type="control_create_clone_of_menu"/>
                    </value>
                </block>
            ` : `
                <block type="control_start_as_clone"/>
                <block type="control_create_clone_of">
                    <value name="CLONE_OPTION">
                        <shadow type="control_create_clone_of_menu"/>
                    </value>
                </block>
                <block type="control_delete_this_clone"/>
            `}
            ${categorySeparator}
        ` : null}
    </category>
    `;
};

const sensing = function (isInitialSetup, isStage) {
    const name = ScratchBlocks.ScratchMsgs.translate('SENSING_ASK_TEXT', 'What\'s your name?');
    return `
    <category name="%{BKY_CATEGORY_SENSING}" id="sensing" colour="#4CBFE6" secondaryColour="#2E8EB8">
        ${isStage ? '' : `
            <block type="sensing_touchingobject">
                <value name="TOUCHINGOBJECTMENU">
                    <shadow type="sensing_touchingobjectmenu"/>
                </value>
            </block>
            <block type="sensing_touchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_coloristouchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
                <value name="COLOR2">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_distanceto">
                <value name="DISTANCETOMENU">
                    <shadow type="sensing_distancetomenu"/>
                </value>
            </block>
            ${blockSeparator}
        `}
        ${isInitialSetup ? '' : `
            <block id="askandwait" type="sensing_askandwait">
                <value name="QUESTION">
                    <shadow type="text">
                        <field name="TEXT">${name}</field>
                    </shadow>
                </value>
            </block>
        `}
        <block id="answer" type="sensing_answer"/>
        ${blockSeparator}
        <block type="sensing_keypressed">
            <value name="KEY_OPTION">
                <shadow type="sensing_keyoptions"/>
            </value>
        </block>
        <block type="sensing_mousedown"/>
        <block type="sensing_mousex"/>
        <block type="sensing_mousey"/>
        ${isStage ? '' : `
            ${blockSeparator}
            '<block type="sensing_setdragmode" id="sensing_setdragmode"></block>'+
            ${blockSeparator}
        `}
        ${blockSeparator}
        <block id="loudness" type="sensing_loudness"/>
        ${blockSeparator}
        <block id="timer" type="sensing_timer"/>
        <block type="sensing_resettimer"/>
        ${blockSeparator}
        <block id="of" type="sensing_of">
            <value name="OBJECT">
                <shadow id="sensing_of_object_menu" type="sensing_of_object_menu"/>
            </value>
        </block>
        ${blockSeparator}
        <block id="current" type="sensing_current"/>
        <block type="sensing_dayssince2000"/>
        ${blockSeparator}
        <block type="sensing_username"/>
        ${categorySeparator}
    </category>
    `;
};

const operators = function (isInitialSetup) {
    const apple = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_APPLE', 'apple');
    const banana = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_BANANA', 'banana');
    const letter = ScratchBlocks.ScratchMsgs.translate('OPERATORS_LETTEROF_APPLE', 'a');
    return `
    <category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
        <block type="operator_add">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_subtract">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_multiply">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_divide">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_random">
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_gt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_lt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_equals">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_and"/>
        <block type="operator_or"/>
        <block type="operator_not"/>
        ${blockSeparator}
        ${isInitialSetup ? '' : `
            <block type="operator_join">
                <value name="STRING1">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
                <value name="STRING2">
                    <shadow type="text">
                        <field name="TEXT">${banana}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_letter_of">
                <value name="LETTER">
                    <shadow type="math_whole_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_length">
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_contains" id="operator_contains">
              <value name="STRING1">
                <shadow type="text">
                  <field name="TEXT">${apple}</field>
                </shadow>
              </value>
              <value name="STRING2">
                <shadow type="text">
                  <field name="TEXT">${letter}</field>
                </shadow>
              </value>
            </block>
        `}
        ${blockSeparator}
        <block type="operator_mod">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_round">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_mathop">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const variables = function () {
    return `
    <category
        name="%{BKY_CATEGORY_VARIABLES}"
        id="variables"
        colour="#FF8C1A"
        secondaryColour="#DB6E00"
        custom="VARIABLE">
    </category>
    `;
};

const myBlocks = function () {
    return `
    <category
        name="%{BKY_CATEGORY_MYBLOCKS}"
        id="myBlocks"
        colour="#FF6680"
        secondaryColour="#FF4D6A"
        custom="PROCEDURE">
    </category>
    `;
};

/* eslint-enable no-unused-vars */

const xmlOpen = '<xml style="display: none">';
const xmlClose = '</xml>';

/**
 * Extrai o primeiro bloco de servo (type contém "ServoOutput") do XML de uma categoria.
 * Considera blocos aninhados (ex.: shadows dentro de value).
 * @param {string} categoryXml - XML da categoria
 * @returns {string|null} XML do bloco ou null se não encontrar
 */
const extractServoBlockFromCategoryXml = function (categoryXml) {
    const blockStartMatch = categoryXml.match(/<block\s[^>]*type="[^"]*ServoOutput[^"]*"[^>]*>/);
    if (!blockStartMatch) return null;
    const startIndex = blockStartMatch.index;
    let depth = 0;
    let i = startIndex;
    const openTag = '<block';
    const closeTag = '</block>';
    // Encontra o fim da tag de abertura <block ...>
    const openEnd = categoryXml.indexOf('>', startIndex);
    if (openEnd === -1) return null;
    i = openEnd + 1;
    depth = 1;
    while (depth > 0 && i < categoryXml.length) {
        const nextOpen = categoryXml.indexOf(openTag, i);
        const nextClose = categoryXml.indexOf(closeTag, i);
        if (nextClose === -1) break;
        if (nextOpen !== -1 && nextOpen < nextClose) {
            depth++;
            i = nextOpen + openTag.length;
        } else {
            depth--;
            if (depth === 0) {
                return categoryXml.substring(startIndex, nextClose + closeTag.length);
            }
            i = nextClose + closeTag.length;
        }
    }
    return null;
};

/**
 * Monta o XML da categoria "Micro Servo" para a extensão de micro servos.
 * @param {string} servoBlockXml - XML do bloco de servo (ex.: set servo pin [PIN] out [OUT])
 * @returns {string} XML da categoria
 */
const buildMicroServoCategoryXml = function (servoBlockXml) {
    const categoryName = '%{microServo.category.name}';
    return `<category name="${categoryName}" id="microServo" colour="#E67E22" secondaryColour="#CC6600">
${servoBlockXml}
${categorySeparator}
</category>`;
};

/**
 * @param {!boolean} isInitialSetup - Whether the toolbox is for initial setup. If the mode is "initial setup",
 * blocks with localized default parameters (e.g. ask and wait) should not be loaded. (LLK/scratch-gui#5445)
 * @param {?object} device - Full data of current selected deivce.
 * @param {?boolean} isStage - Whether the toolbox is for a stage-type target. This is always set to true
 * when isInitialSetup is true.
 * @param {?string} targetId - The current editing target
 * @param {?Array.<object>} categoriesXML - optional array of `{id,xml}` for categories. This can include both core
 * and other extensions: core extensions will be placed in the normal Scratch order; others will go at the bottom.
 * @property {string} id - the extension / category ID.
 * @property {string} xml - the `<category>...</category>` XML for this extension / category.
 * @param {?boolean} isRealtimeMode - Current program mode.
 * @param {?string} costumeName - The name of the default selected costume dropdown.
 * @param {?string} backdropName - The name of the default selected backdrop dropdown.
 * @param {?string} soundName -  The name of the default selected sound dropdown.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
// Função auxiliar para traduzir texto de blocos
const translateBlockText = function (text) {
    if (!text) return text;
    
    // Traduções diretas
    const translations = {
        'set pin [PIN] mode [MODE]': 'definir pino [PIN] modo [MODE]',
        'set digital pin [PIN] out [LEVEL]': 'definir pino digital [PIN] saída [LEVEL]',
        'set pwm pin [PIN] out [OUT]': 'definir pino pwm [PIN] saída [OUT]',
        'set servo pin [PIN] out [OUT]': 'definir pino servo [PIN] saída [OUT]',
        'read digital pin [PIN]': 'ler pino digital [PIN]',
        'read analog pin [PIN]': 'ler pino analógico [PIN]',
        'attach interrupt pin [PIN] mode [MODE] executes': 'anexar interrupção pino [PIN] modo [MODE] executa',
        'detach interrupt pin [PIN]': 'desanexar interrupção pino [PIN]',
        'serial [NO] begin baudrate [VALUE]': 'serial [NO] iniciar taxa de transmissão [VALUE]',
        'serial [NO] print [VALUE] [EOL]': 'serial [NO] imprimir [VALUE] [EOL]',
        'serial [NO] available data length': 'serial [NO] comprimento de dados disponível',
        'serial [NO] read a byte': 'serial [NO] ler um byte',
        'constrain [DATA] between ([ARG0], [ARG1])': 'limitar [DATA] entre ([ARG0], [ARG1])',
        'convert [DATA] to [TYPE]': 'converter [DATA] para [TYPE]',
        'convert [DATA] to ASCII character': 'converter [DATA] para caractere ASCII',
        'convert [DATA] to ASCII nubmer': 'converter [DATA] para número ASCII',
        'map [DATA] from ([ARG0], [ARG1]) to ([ARG2], [ARG3])': 'mapear [DATA] de ([ARG0], [ARG1]) para ([ARG2], [ARG3])'
    };
    
    // Tenta tradução direta primeiro
    if (translations[text]) {
        return translations[text];
    }
    
    // Tenta padrões com valores reais usando regex
    let translated = text
        .replace(/^set pin (\d+) mode (input|output|input-pullup)$/i, 'definir pino $1 modo $2')
        .replace(/^set digital pin (\d+) out (high|low)$/i, 'definir pino digital $1 saída $2')
        .replace(/^set pwm pin (\d+) out (\d+)$/i, 'definir pino pwm $1 saída $2')
        .replace(/^set servo pin (\d+) out (\d+)$/i, 'definir pino servo $1 saída $2')
        .replace(/^read digital pin (\d+)$/i, 'ler pino digital $1')
        .replace(/^read analog pin (A\d+|\d+)$/i, 'ler pino analógico $1')
        .replace(/^attach interrupt pin (\d+) mode (rising edge|falling edge|change edge|low) executes$/i, 'anexar interrupção pino $1 modo $2 executa')
        .replace(/^detach interrupt pin (\d+)$/i, 'desanexar interrupção pino $1')
        .replace(/^serial (\d+) begin baudrate (\d+)$/i, 'serial $1 iniciar taxa de transmissão $2')
        .replace(/^serial (\d+) print (.+) (warp|no warp)$/i, 'serial $1 imprimir $2 $3')
        .replace(/^serial (\d+) available data length$/i, 'serial $1 comprimento de dados disponível')
        .replace(/^serial (\d+) read a byte$/i, 'serial $1 ler um byte')
        .replace(/^constrain (\d+) between \((\d+), (\d+)\)$/i, 'limitar $1 entre ($2, $3)')
        .replace(/^convert (.+) to (integer|decimal|string)$/i, 'converter $1 para $2')
        .replace(/^convert (\d+) to ASCII character$/i, 'converter $1 para caractere ASCII')
        .replace(/^convert (.+) to ASCII nubmer$/i, 'converter $1 para número ASCII')
        .replace(/^map (\d+) from \((\d+), (\d+)\) to \((\d+), (\d+)\)$/i, 'mapear $1 de ($2, $3) para ($4, $5)');
    
    // Se mudou, traduz valores também
    if (translated !== text) {
        translated = translated
            .replace(/\binput\b/gi, 'entrada')
            .replace(/\boutput\b/gi, 'saída')
            .replace(/\binput-pullup\b/gi, 'entrada-pullup')
            .replace(/\bhigh\b/gi, 'alto')
            .replace(/\blow\b/gi, 'baixo')
            .replace(/\brising edge\b/gi, 'borda de subida')
            .replace(/\bfalling edge\b/gi, 'borda de descida')
            .replace(/\bchange edge\b/gi, 'mudar borda')
            .replace(/\binteger\b/gi, 'inteiro')
            .replace(/\bdecimal\b/gi, 'decimal')
            .replace(/\bstring\b/gi, 'texto')
            .replace(/\bwarp\b/gi, 'com quebra')
            .replace(/\bno warp\b/gi, 'sem quebra');
    }
    
    return translated;
};

const makeToolboxXML = function (isInitialSetup, device = null, isStage = true, targetId, categoriesXML = [],
    isRealtimeMode = true,
    costumeName = '', backdropName = '', soundName = '', loadedCustomExtensions = []) {
    isStage = isInitialSetup || isStage;
    const gap = [categorySeparator];

    costumeName = xmlEscape(costumeName);
    backdropName = xmlEscape(backdropName);
    soundName = xmlEscape(soundName);
    categoriesXML = categoriesXML.slice();

    // Injeta categorias de extensões customizadas carregadas (independente de device selecionado)
    // Importação dinâmica para evitar dependência circular
    if (loadedCustomExtensions && loadedCustomExtensions.length > 0) {
        try {
            // eslint-disable-next-line global-require
            const {getCustomExtensionById} = require('./custom-device-extensions');
            for (const extId of loadedCustomExtensions) {
                const customExt = getCustomExtensionById(extId);
                if (customExt && customExt.buildCategoryXml) {
                    // Verifica se a categoria já existe antes de construir
                    const existingIndex = categoriesXML.findIndex(cat => cat.id === customExt.categoryId);
                    if (existingIndex < 0) {
                        // Só constrói se não existir ainda
                        const categoryXml = customExt.buildCategoryXml(categoriesXML);
                        if (categoryXml) {
                            // Adiciona nova categoria no início das extensões
                            categoriesXML.unshift({id: customExt.categoryId, xml: categoryXml});
                        } else {
                            // Fallback: usa buildCategoryWithBlocks para categoria com blocos
                            let categoryName = extId;
                            let categoryColor = '#E67E22';
                            let categorySecondaryColor = '#CC6600';
                            if (extId === 'microServo') {
                                categoryName = '%{microServo.category.name}';
                            } else if (extId === 'photoResistorSensor') {
                                categoryName = '%{photoResistorSensor.category.name}';
                                categoryColor = '#4C97FF';
                                categorySecondaryColor = '#3373CC';
                            } else if (extId === 'ultrasonicSensor') {
                                categoryName = '%{ultrasonicSensor.category.name}';
                                categoryColor = '#4C97FF';
                                categorySecondaryColor = '#3373CC';
                            } else if (extId === 'linetracingIRSensor') {
                                categoryName = '%{linetracingIRSensor.category.name}';
                                categoryColor = '#4C97FF';
                                categorySecondaryColor = '#3373CC';
                            } else if (extId === 'dht11Sensor') {
                                categoryName = '%{dht11Sensor.category.name}';
                                categoryColor = '#4C97FF';
                                categorySecondaryColor = '#3373CC';
                            }
                            let fallbackXml = null;
                            try {
                                const {buildCategoryWithBlocks} = require('./custom-extension-blocks');
                                fallbackXml = buildCategoryWithBlocks(extId, categoryName, categoryColor, categorySecondaryColor);
                            } catch (e) {
                                // ignora
                            }
                            if (!fallbackXml) {
                                fallbackXml = `<category name="${categoryName}" id="${customExt.categoryId}" colour="${categoryColor}" secondaryColour="${categorySecondaryColor}">
${categorySeparator}
</category>`;
                            }
                            categoriesXML.unshift({id: customExt.categoryId, xml: fallbackXml});
                        }
                    }
                }
            }
        } catch (e) {
            // Ignora erros de importação (extensões customizadas podem não estar disponíveis)
            console.warn('Failed to load custom extensions:', e); // eslint-disable-line no-console
        }
    }

    const moveCategory = categoryId => {
        const index = categoriesXML.findIndex(categoryInfo => categoryInfo.id === categoryId);
        if (index >= 0) {
            // remove the category from categoriesXML and return its XML
            const [categoryInfo] = categoriesXML.splice(index, 1);
            return categoryInfo.xml;
        }
        // return `undefined`
    };

    const everything = [];

    const motionXML = moveCategory('motion') || motion(isInitialSetup, isStage, targetId);
    const looksXML = moveCategory('looks') || looks(isInitialSetup, isStage, targetId, costumeName, backdropName);
    const soundXML = moveCategory('sound') || sound(isInitialSetup, isStage, targetId, soundName);
    let eventsXML = moveCategory('event') || events(isInitialSetup, isStage, targetId);
    const controlXML = moveCategory('control') || control(isInitialSetup, isStage, targetId, isRealtimeMode);
    const sensingXML = moveCategory('sensing') || sensing(isInitialSetup, isStage, targetId);
    const operatorsXML = moveCategory('operators') || operators(isInitialSetup, isStage, targetId);
    const variablesXML = moveCategory('data') || variables(isInitialSetup, isStage, targetId);
    const myBlocksXML = moveCategory('procedures') || myBlocks(isInitialSetup, isStage, targetId);

    if (device && !isRealtimeMode) {
        eventsXML = `
        <category name="%{BKY_CATEGORY_EVENTS}" id="events" colour="#FFD500" secondaryColour="#CC9900">
            ${eventBlock[device.type]}
            ${categorySeparator}
        </category>
    `;
        everything.push(
            xmlOpen,
            eventsXML, gap,
            controlXML, gap,
            operatorsXML, gap,
            variablesXML, gap,
            myBlocksXML
        );
    } else {
        everything.push(
            xmlOpen,
            motionXML, gap,
            looksXML, gap,
            soundXML, gap,
            eventsXML, gap,
            controlXML, gap,
            sensingXML, gap,
            operatorsXML, gap,
            variablesXML, gap,
            myBlocksXML
        );
    }

    
    for (const extensionCategory of categoriesXML) {
        // Traduz os nomes das categorias das extensões se necessário
        let categoryXML = extensionCategory.xml;
        
        // Traduz blockInfo.text diretamente no XML antes de ser processado
        if (categoryXML && categoryXML.includes('blockInfo')) {
            // Intercepta blockInfo no XML e traduz o texto
            categoryXML = categoryXML.replace(/blockInfo="([^"]*)"/g, (match, blockInfoJson) => {
                try {
                    let blockInfo = JSON.parse(decodeURIComponent(blockInfoJson));
                    if (blockInfo && blockInfo.text) {
                        const translated = translateBlockText(blockInfo.text);
                        if (translated !== blockInfo.text) {
                            blockInfo.text = translated;
                            return `blockInfo="${encodeURIComponent(JSON.stringify(blockInfo))}"`;
                        }
                    }
                } catch (e) {
                    try {
                        let blockInfo = JSON.parse(blockInfoJson);
                        if (blockInfo && blockInfo.text) {
                            const translated = translateBlockText(blockInfo.text);
                            if (translated !== blockInfo.text) {
                                blockInfo.text = translated;
                                return `blockInfo="${encodeURIComponent(JSON.stringify(blockInfo))}"`;
                            }
                        }
                    } catch (e2) {
                        // Ignora erros
                    }
                }
                return match;
            });
        }
        
        if (ScratchBlocks && ScratchBlocks.ScratchMsgs && ScratchBlocks.ScratchMsgs.locales) {
            const currentLocale = ScratchBlocks.ScratchMsgs.currentLocale || 'en';
            const translations = ScratchBlocks.ScratchMsgs.locales[currentLocale] || {};
            
            // Verifica se é categoria relacionada a pins
            const isPinsCategory = extensionCategory.id && (
                extensionCategory.id.includes('arduinoUno') || 
                extensionCategory.id.includes('arduinoMega2560') ||
                extensionCategory.id.includes('arduino_pin') ||
                extensionCategory.id.includes('pins') ||
                categoryXML.toLowerCase().includes('pin')
            );
            
            // Tenta traduções tanto para pt-br quanto para en (fallback)
            const ptBrTranslations = ScratchBlocks.ScratchMsgs.locales['pt-br'] || {};
            const allTranslations = {...translations, ...ptBrTranslations};
            
            
            // Procura por nomes de categorias que precisam ser traduzidos
            // Formato esperado: <category name="arduinoUno.category.pins" ou name="Pins" ou name="%{arduinoUno.category.pins}"
            categoryXML = categoryXML.replace(
                /<category\s+([^>]*)>/g,
                (match, attributes) => {
                    // Extrai o atributo name
                    const nameMatch = attributes.match(/name="([^"]+)"/);
                    if (!nameMatch) return match;
                    
                    const nameAttr = nameMatch[1];
                    const extensionId = extensionCategory.id || '';
                    
                    // Tenta traduções tanto para o locale atual quanto pt-br
                    const ptBrTranslations = ScratchBlocks.ScratchMsgs.locales['pt-br'] || {};
                    const allTranslations = {...translations, ...ptBrTranslations};
                    
                    // Se o nome usa o formato %{KEY}, extrai a chave
                    let translationKey = null;
                    if (nameAttr.startsWith('%{') && nameAttr.endsWith('}')) {
                        translationKey = nameAttr.slice(2, -1);
                    } else if (nameAttr.includes('.')) {
                        // Se o nome é uma chave de tradução (contém ponto)
                        translationKey = nameAttr;
                    } else if (extensionId) {
                        // Se o nome é direto em inglês, tenta encontrar a chave de tradução
                        const categoryNameLower = nameAttr.toLowerCase();
                        
                        // arduino_pin -> arduinoUno / arduinoMega2560 (mesmos blocos, IDs distintos no VM)
                        let extensionIdForTranslation = extensionId;
                        if (extensionId.startsWith('arduino_')) {
                            extensionIdForTranslation = 'arduinoUno';
                        }

                        const possibleKeys = [
                            `arduinoMega2560.category.${categoryNameLower}`,
                            `arduinoMega2560.category.${nameAttr}`,
                            `${extensionIdForTranslation}.category.${categoryNameLower}`,
                            `${extensionIdForTranslation}.category.${nameAttr}`,
                            `${extensionId}.category.${categoryNameLower}`,
                            `${extensionId}.category.${nameAttr}`,
                            `${extensionIdForTranslation}.categoryName.${categoryNameLower}`
                        ];
                        
                        for (const key of possibleKeys) {
                            if (allTranslations[key]) {
                                translationKey = key;
                                break;
                            }
                        }
                    }
                    
                    // Aplica a tradução se encontrou uma chave válida
                    if (translationKey && allTranslations[translationKey]) {
                        const translated = allTranslations[translationKey];
                        // Substitui o atributo name com a tradução
                        const newAttributes = attributes.replace(
                            /name="[^"]+"/,
                            `name="${translated}"`
                        );
                        return `<category ${newAttributes}>`;
                    }
                    
                    // Se não encontrou tradução mas o nome é direto em inglês e temos o extensionId,
                    // tenta usar o formato %{KEY} para que o ScratchBlocks traduza automaticamente
                    if (!translationKey && extensionId && nameAttr && !nameAttr.includes('.') && !nameAttr.startsWith('%{')) {
                        const categoryNameLower = nameAttr.toLowerCase();
                        
                        // Mapeia IDs de categoria para IDs de extensão
                        let extensionIdForTranslation = extensionId;
                        if (extensionId.startsWith('arduino_')) {
                            extensionIdForTranslation = 'arduinoUno';
                        }
                        
                        const possibleKeys = [
                            `arduinoMega2560.category.${categoryNameLower}`,
                            `${extensionIdForTranslation}.category.${categoryNameLower}`
                        ];
                        const possibleKey = possibleKeys.find(key => allTranslations[key]);
                        
                        if (allTranslations[possibleKey]) {
                            // Usa o formato %{KEY} para tradução automática pelo ScratchBlocks
                            const newAttributes = attributes.replace(
                                /name="[^"]+"/,
                                `name="%{${possibleKey}}"`
                            );
                            return `<category ${newAttributes}>`;
                        }
                    }
                    
                    return match;
                }
            );
        }
        everything.push(gap, categoryXML);
    }

    everything.push(xmlClose);
    return everything.join('\n');
};

export default makeToolboxXML;

